module.exports = __webpack_public_path__ + "img/video.ac85b9f0.png";